import environment from "@menu-environment";

const imageSrc = (image: string) => {
    const imagePrefix = environment.menu.urls.imagePrefix;
    return `${imagePrefix}${image}`;
}

export default imageSrc;